/* BLUND — bundle upsell card injected just above the Add to cart buttons */
(function(){
  function run(){
    var buy = document.querySelector('.vita-pdp__buy');
    if(!buy || document.querySelector('.vita-pdp__bundle')) return;
    if(location.pathname.indexOf('/products/the-blund-sleep-bundle') > -1) return;
    fetch('/products/the-blund-sleep-bundle.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(bp){
        if(!bp || bp.available === false) return;
        var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
        var price;
        try { price = (bp.price/100).toLocaleString(undefined,{style:'currency',currency:cur}); }
        catch(e){ price = (bp.price/100).toFixed(2)+' '+cur; }
        var img = bp.featured_image || (bp.images && bp.images[0]) || '';
        if(img && img.indexOf('http')!==0 && img.indexOf('//')!==0){ img = '//' + img.replace(/^\/*/,''); }
        var sep = img.indexOf('?')>-1 ? '&' : '?';
        var a = document.createElement('a');
        a.href = bp.url || '/products/the-blund-sleep-bundle';
        a.className = 'vita-pdp__bundle';
        a.setAttribute('aria-label','Shop the complete BLUND Sleep Bundle');
        a.innerHTML =
          '<span class="vita-pdp__bundle-media">' + (img ? '<img src="'+img+sep+'width=180" width="76" height="76" loading="lazy" alt="">' : '') + '</span>' +
          '<span class="vita-pdp__bundle-txt">' +
            '<span class="vita-pdp__bundle-tag">Best value · Save more</span>' +
            '<strong class="vita-pdp__bundle-title">Complete the night ritual — all&nbsp;3</strong>' +
            '<span class="vita-pdp__bundle-sub">Gummies + Sleep Patch + Nasal Strips &amp; Mouth Tape · <b>'+price+'</b></span>' +
          '</span>' +
          '<span class="vita-pdp__bundle-cta">Shop bundle &rarr;</span>';
        buy.parentNode.insertBefore(a, buy);
      })
      .catch(function(){});
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', run); }
  else { run(); }
  document.addEventListener('shopify:section:load', run);
})();
